import { DirectiveOptions } from 'vue';

/**
 * Helper function to calculate the left and top positions of a trigger html element
 * 
 * @param el The element we need to do extra work on before adding to the DOM
 * @param context The vue component we are currently working with
 */
function calculatePosition(el: HTMLElement, context: Vue | undefined) {
  if (context !== undefined && context.toggle !== undefined && context.calculatePosition !== undefined && typeof context.calculatePosition === 'function') {
    el.style.position = 'absolute';

    const { height, top, left, width }= context.toggle.getBoundingClientRect();
    const scrollX = window.scrollX || window.pageXOffset;
    const scrollY = window.scrollY || window.pageYOffset;
    el.unbindPosition = context.calculatePosition(el, context, width, height, (scrollX + top + height), (scrollY + left));
    el.style.zIndex = '1000';

    if (el.parentElement !== document.body) {
      document.body.appendChild(el);
    }
  }
}

export const appendToBody: DirectiveOptions = {
  /**
   * Directive event when this element is inserted into the DOM
   * 
   * @param el The element we are triggering on
   * @param binding The binding that we should look into for extra params
   * @param context The context vue component
   */
  inserted(el, binding, { context }) {
    calculatePosition(el, context);
  },

  /**
   * Directive event when this element is updated on the DOM
   * 
   * @param el The element we are triggering on
   * @param binding The binding that we should look into for extra params
   * @param context The context vue component
   */
  update(el, bindings, { context }) {
    calculatePosition(el, context);
  },

  /**
   * Directive event when this element is removed from the DOM
   * 
   * @param el The element we are triggering on
   * @param binding The binding that we should look into for extra params
   * @param context The context vue component
   */
  unbind(el, bindings, { context }) {
    if (context !== undefined && context.calculatePosition !== undefined) {
      if (el.unbindPosition && typeof el.unbindPosition === 'function') {
        el.unbindPosition();
      }
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  }
};
